import React from 'react';
import { Layout, Divider } from 'antd';
import { Link } from 'react-router-dom';


const { Footer } = Layout;

const FooterStyle = () => (
    <Footer style={{ 
        display:'flex', 
        flexDirection:'column', 
        width: '100%', 
        textAlign: 'center', 
        padding: '1rem 0', 
        backgroundColor: '#1f386e', 
        zIndex: '101', 
        color: '#fff', 
        fontWeight:'200', 
        fontFamily: 'Arial, Helvetica, sans-serif',
        // boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.1)'
        boxShadow:'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
    }}>   

        <div style={{ width: '100%', textAlign: 'center', zIndex: '101', color: '#fff', fontWeight:'300', padding:'0.5rem 0' }}>
                © {new Date().getFullYear()} Kombinasi Saudagar Sdn. Bhd. | All Rights Reserved. | Reg No. 201601018252 (1189188-A)
        </div> 

        {/* <Divider style={{ color:'white' }}/>  */}

        <div style={{ display:'flex', flexDirection:'row', width: '100%', justifyContent:'space-around', zIndex: '101', color: '#fff', fontWeight:'200', padding:'0.5rem 0'}}>
            <div className='link' style={{ display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                <Link to='/' style={{  color:'#fff', borderRight:'1px solid #fff', float:'left', padding:'0 15px'}}>Home</Link>
                <Link to='/aboutus' style={{  color:'#fff', borderRight:'1px solid #fff', float:'left', padding:'0 15px'}}>About</Link>
                <Link to='/career' style={{  color:'#fff', borderRight:'1px solid #fff', float:'left', padding:'0 15px'}}>Career</Link>
                <Link to='/contact' style={{ margin:'0 0.5rem', color:'#fff'}}>Contact us</Link>
            </div> 
        </div>
         
    </Footer>
    
);
export default FooterStyle;